module.exports = __webpack_public_path__ + "static/img/logo.38b147e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/logo.png
// module id = q+N8
// module chunks = 0 1 2 9 18 22 24 25 31 32 34 38 42 43 44 50 51 52 53 54 55 70 72 93 95 96 97 98 99 100 101 102 108